import React from 'react';
import PropTypes from 'prop-types';
import {Button, Link, Stack} from '@customink/pigment-react';

import Notification from '~/components/Notification';

import {SUPPORT_PHONE_NUMBER} from '~/constants/ContactConstants';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function FailedLoadSleeveProductImage(props) {
  const {dismiss} = props;

  return (
    <Notification
      dismiss={dismiss}
      title="Unable to load sleeve image"
      type="ERROR">
      <br />
      <p className="ndx-cta1">
        Reach out if you need help to add or adjust a sleeve design on this
        product and we'll make sure your design looks great.
      </p>
      <Stack className="notification-stack">
        <Button
          className="notification-cta"
          size="large"
          variant="secondary"
          onClick={dismiss}>
          Okay
        </Button>
        <p className="ndx-cta1">
          or call{' '}
          <Link href={SUPPORT_PHONE_NUMBER.TEL_LINK}>
            {SUPPORT_PHONE_NUMBER.COPY}
          </Link>
          .
        </p>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

FailedLoadSleeveProductImage.propTypes = propTypes;

FailedLoadSleeveProductImage.displayName = 'FailedLoadSleeveProductImage';
